import styled, { css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

/** Leaf module — avoids AssetFilter ↔ filters.style circular import. */
export const CustomFilterPopover = styled.div<{ $width?: string; $maxHeight?: number }>`
  &:not(.ant-table-filter-dropdown-checkboxes) {
    min-width: 16rem;
    max-width: 32rem;
  }
  ${({ $width }) => ($width ? `width: ${$width}` : '')};
  ${({ $maxHeight }) =>
    $maxHeight != null
      ? css`
          display: flex;
          flex-direction: column;
          max-height: ${$maxHeight}px;
          overflow: hidden;
        `
      : ''}

  ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? css`
          background-color: ${theme.tertiaryBackgroundColor} !important;
        `
      : ''}
`;
